__turbopack_context__.v({
  "addressContent": "_9b0g1W_addressContent",
  "addressTitle": "_9b0g1W_addressTitle",
  "addressWrapper": "_9b0g1W_addressWrapper",
  "addressesWrapper": "_9b0g1W_addressesWrapper",
  "buttonsWrapper": "_9b0g1W_buttonsWrapper",
  "informationWrapper": "_9b0g1W_informationWrapper",
  "labelWrapper": "_9b0g1W_labelWrapper",
  "modalButtonsWrapper": "_9b0g1W_modalButtonsWrapper",
});
